// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"17e38061","308":"886d2924","453":"4991c3ad","554":"72adc42d","619":"545c992e"}[chunkId] + ".chunk.js";
};